import InfoCircleOutlineSvg from '@assets/images/svg/info-circle-outline.svg';
import React from 'react';
import { View } from 'react-native';

export interface InfoCircleOutlineIconProps {
    size?: number;
    color?: string;
}

export function InfoCircleOutlineIcon({ size = 14, color = '#A0A0B0' }: Readonly<InfoCircleOutlineIconProps>) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <InfoCircleOutlineSvg width={size} height={size} color={color} />
        </View>
    );
}

export default InfoCircleOutlineIcon;
